class Interceptors{
	static requestInterceptor:number|null = null
	static responseInterceptor:number|null = null
	static accessToken:string|null = null
	static accessTokenExpires:number|null = null
}

export default Interceptors